import { inject } from '@angular/core';
import { Router, type CanActivateFn, type UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import type { AccountInfo } from '@azure/msal-browser';
import { resolveActiveAccount } from './active-account';
import { userHasEFilingAccess } from './e-filing.guard';
import { userHasQuoteLogAccess } from './quote-log.guard';

// Shared check used by both the route guard and the navigation link.
// Reporting surfaces the same underlying invoice data as E-Filing, so anyone
// who can already see E-Filing or Quote Log can also see Reporting.
export function userHasReportingAccess(account: AccountInfo | null): boolean {
	return userHasEFilingAccess(account) || userHasQuoteLogAccess(account);
}

export const reportingGuard: CanActivateFn = (): boolean | UrlTree => {
	const msalService = inject(MsalService);
	const router = inject(Router);

	if (userHasReportingAccess(resolveActiveAccount(msalService))) {
		return true;
	}

	return router.createUrlTree(['/']);
};
